import classNames from 'classnames';
import { type ComponentPropsWithoutRef, memo, type ReactNode } from 'react';

import { Button } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

import { RotatingDowntick } from '~/components/RotatingDowntick';
import { LIST_SECTION_TITLE } from '~/constants/testIDs';

export type ListSectionHeaderProps = {
  headerTitle: ReactNode;
  /** click handler */
  onClick?: () => void;
  /** true if section is collapsed */
  collapsed?: boolean;
  showDowntick?: 'always' | 'hover-only';
} & ComponentPropsWithoutRef<'div'>;

export const ListSectionHeader = memo(
  ({
    className,
    collapsed = false,
    headerTitle,
    onClick,
    children,
    showDowntick = 'hover-only',
    ...rest
  }: ListSectionHeaderProps) => {
    return (
      <div className={cn('relative flex items-end justify-between pb-4', className)} {...rest}>
        <Button
          appearance="ghost"
          color="gray"
          className={classNames('group/list-section-header -ml-2', onClick ? 'cursor-pointer' : 'cursor-default')}
          size="small"
          onClick={onClick}
          data-testid={LIST_SECTION_TITLE}
        >
          <div className="relative bg-transparent font-bold ads:text-metadata text-12 text-gray-10 uppercase">
            {headerTitle}
          </div>

          {!!onClick && (
            <div
              className={classNames(
                'pointer-events-none ml-1 group-hover/list-section-header:opacity-100',
                showDowntick === 'hover-only' ? 'opacity-0' : 'opacity-100',
              )}
            >
              <RotatingDowntick rotate={collapsed} />
            </div>
          )}
        </Button>
        {children}
      </div>
    );
  },
);

ListSectionHeader.displayName = 'ListSectionHeader';
